import "./AOSmithWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import AOSmithHero from "./sections/AOSmithHero";
import AosmithServices from "./sections/AosmithServices";
import BrandFaq from "./sections/BrandFaq";
import Footer from "@/reusable_sections/Footer";
export default function AOSmithWaterHeaterServicePage() {
  return <div>
      <Header />
      <AOSmithHero />
      <AosmithServices />
      <BrandFaq />
      <Footer />
    </div>;
}